<template>
  <div class="row" v-for="p in sorted_pools" :key="p.id">
    <FlashPool :pool_id="p.id"></FlashPool>
  </div>
</template>
<script setup>
import supabase from "@/supabase/config";
import { onMounted, ref, computed } from "vue";
import { useStore } from "@/store/index";
import FlashPool from "./FlashPool.vue";
const store = useStore();
const all_pools = ref([]);
onMounted(() => {
  fetchPools();
});
const fetchPools = async () => {
  let { data: pools, error } = await supabase
    .from("pools")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_pools.value = pools;
};
const sorted_pools = computed(() => {
  var arr = [];
  all_pools.value.forEach((p) => {
    arr.push(p);
  });
  var sorted_arr = [];
  sorted_arr = [...arr].sort((a, b) => a.sort - b.sort);
  return sorted_arr;
});
</script>
